import { render } from "./SearchResultsDisplay.vue?vue&type=template&id=0f657600"
import script from "./SearchResultsDisplay.vue?vue&type=script&lang=js"
export * from "./SearchResultsDisplay.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__